import * as _ from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { User } from '../shared/user.model';
import { UserFactory } from '../shared/user.factory';
import { UserService } from '../shared/user.service';
import { RoleService } from 'app/settings/roles/shared/role.service';
import { HttpParams } from '@angular/common/http';
import { GroupService } from 'app/settings/groups/shared/group.service';
import { GlobalService } from 'app/shared/global.service';

@Component({
    selector: 'app-profile-edit',
    templateUrl: './profile-edit.component.html'
})

export class ProfileEditComponent implements OnInit {

    public model = UserFactory.empty();
    public loading = false;
    public isSaved = false;
    public password: string;
    public passwordRepeat: string;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private globalService: GlobalService,
        private userService: UserService) {
    }

    save() {
        const model = UserFactory.fromObject(this.model);
        this.loading = true;
        this.userService.createOrUpdate(model).subscribe(result => {
            this.isSaved = true;
            this.loading = false;

            if (this.model.password) {
                this.router.navigate(['/login'], { relativeTo: this.activatedRoute });
            }
        });
    }

    hasOutOfOffice(item): boolean {
        if (!item.role) {
            return false;
        }
        if (item.role && item.role.outOfOffice) {
            return true;
        }
        let result = false;
        _.forEach(item.rights, (right) => {
            if (right.role && right.role.outOfOffice) {
                result = true;
            }
        })
        return result;
    }

    ngOnInit() {
        this.loading = true;
        this.globalService.$currentUser.subscribe((currentUser) => {
            this.loadData(currentUser);
        });

        this.loadData(this.globalService.currentUser);
    }

    loadData(currentUser) {
        if (currentUser) {
            this.userService.getSingle(currentUser.id).subscribe(result => {
                this.model = result;
                this.loading = false;
            });
        }
    }

    passwordsMatch(): boolean {
        if (!this.model.password) {
            return true;
        }
        if (!this.passwordRepeat) {
            return true;
        }
        return this.model.password === this.passwordRepeat;
    }
}



// WEBPACK FOOTER //
// ./src/app/users/profile-edit/profile-edit.component.ts